import React from 'react';

import { changeDeal } from 'bundles/apex/deals/form/store/deal/actions';
import { loadFields } from 'bundles/apex/deals/form/store/fields/actions';
import { useDispatch, useSelector } from 'bundles/apex/deals/form/store/hooks';

import ResearchPropertyAsyncSelect from 'components/research_property/async_select';

import type { Deal } from 'bundles/apex/deals/types';

const mappings = [
  {
    fieldName: 'address',
    propertyNamesByDealName: {
      address: 'address',
    },
  },
  {
    fieldName: 'buildingSize',
    propertyNamesByDealName: {
      buildingSize: 'buildingSize',
    },
  },
  {
    fieldName: 'city',
    propertyNamesByDealName: {
      city: 'city',
    },
  },
  {
    fieldName: 'country',
    needsFieldReload: true,
    propertyNamesByDealName: {
      countryId: 'countryId',
    },
  },
  {
    fieldName: 'county',
    propertyNamesByDealName: {
      county: 'county',
    },
  },
  {
    fieldName: 'lotSize',
    propertyNamesByDealName: {
      lotSize: 'lotSize',
    },
  },
  {
    fieldName: 'numberOfUnits',
    propertyNamesByDealName: {
      numberOfUnits: 'numberOfUnits',
    },
  },
  {
    fieldName: 'occupancyPercent',
    propertyNamesByDealName: {
      occupancyPercent: 'occupancyPct',
    },
  },
  {
    fieldName: 'propertyName',
    propertyNamesByDealName: {
      propertyName: 'name',
    },
  },
  {
    fieldName: 'propertyType',
    needsFieldReload: true,
    propertyNamesByDealName: {
      propertyTypeId: 'propertyTypeId',
      propertySubtypeId: 'propertySubtypeId',
    },
  },
  {
    fieldName: 'state',
    propertyNamesByDealName: {
      state: 'state',
    },
  },
  {
    fieldName: 'yearBuilt',
    propertyNamesByDealName: {
      yearBuilt: 'yearBuilt',
    },
  },
  {
    fieldName: 'zip',
    propertyNamesByDealName: {
      zip: 'zip',
    },
  },
];

export default function Property() {
  const deal = useSelector(state => state.deal);
  const edgeCrm = useSelector(state => state.features.edgeCrm);
  const fields = useSelector(state => state.fields);
  const hidePropertySelector = useSelector(state => state.hidePropertySelector);
  const dispatch = useDispatch();

  if (
    deal.id
    || !edgeCrm
    || hidePropertySelector
    || mappings.every(mapping => !fields[mapping.fieldName] || fields[mapping.fieldName].hidden)
  ) {
    return null;
  }

  function handleSelect(property) {
    const changes: Partial<Deal> = { researchPropertyId: null };
    let needsFieldReload = false;

    property = property || {};
    changes.researchPropertyId = property.id;

    for (const mapping of mappings) {
      for (const dealName in mapping.propertyNamesByDealName) {
        changes[dealName] = property[mapping.propertyNamesByDealName[dealName]];
      }

      if (mapping.needsFieldReload) {
        needsFieldReload = mapping.needsFieldReload;
      }
    }

    dispatch(changeDeal(changes));

    if (needsFieldReload) {
      dispatch(loadFields());
    }
  }

  return (
    <div className="mb-3">
      <span className="fs-small">Search for a property to connect, or fill out the form directly</span>
      <ResearchPropertyAsyncSelect onSelect={handleSelect} />
    </div>
  );
}
